import { DateTime } from 'luxon';
import { useSearchParams } from 'react-router-dom';

import { TimeRangeInput } from 'dashboards/types/time';

import { USER_TIMEZONE } from 'services/timezone';

export type TimeRangeParams = TimeRangeInput & {
  preset: string;
  timezone: string;
};

export function adjustTimezoneAndKeepLocalTime({
  timezone,
  date,
}: {
  timezone: string;
  date: DateTime;
}) {
  return date.setZone(timezone, { keepLocalTime: true }).toISO();
}

export function useTimeRangeParams(): TimeRangeParams {
  const [params] = useSearchParams();

  const preset = params.get('preset') || 'TODAY';
  const timezone = params.get('timezone') || USER_TIMEZONE;
  const start =
    params.get('start') ||
    adjustTimezoneAndKeepLocalTime({
      timezone,
      date: DateTime.now().startOf('day'),
    })!;
  const stop =
    params.get('stop') ||
    adjustTimezoneAndKeepLocalTime({
      timezone,
      date: DateTime.now().endOf('day'),
    })!;

  return {
    preset,
    start,
    stop,
    timezone,
  };
}
